import React, { memo } from 'react';
var MapPath = memo(function (_a) {
    var fill = _a.fill, path = _a.path, stroke = _a.stroke;
    return (React.createElement("path", { d: path, fill: fill, strokeWidth: "0.5", stroke: stroke }));
});
MapPath.displayName = 'MapPath';
export default MapPath;
